import { useQuery } from "react-query";
import http from "infra/http";
import { AxiosError } from "axios";
import { OrcamentoCotacaoFornecedor } from 'features/orcamento/typings';

export function useListarCotacao(id?: string) {
  return useQuery<OrcamentoCotacaoFornecedor[], AxiosError>(
    `/v1/orcamento/${id}/cotacao`,
    async () => {
      const { data } = await http.get<OrcamentoCotacaoFornecedor[]>(
        `/v1/orcamento/${id}/cotacao`
      );

      return data;
    },
    { enabled: !!id }
  );
}
